import type { ComponentType, FC } from 'react';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
interface IRenderComponentsProps extends Record<string, any> {
  MobileComponent?: ComponentType<any>;
  TabletComponent?: ComponentType<any>;
  DesktopComponent: ComponentType<any>;
  forceDesktop?: boolean;
}
const RenderComponents: FC<IRenderComponentsProps> = ({
  MobileComponent,
  forceDesktop,
  TabletComponent,
  DesktopComponent,
  ...props
}) => {
  const deviceType = useDeviceType();
  if ([DeviceType.MOBILE, DeviceType.TABLET].includes(deviceType) && !forceDesktop && MobileComponent) {
    if (deviceType === DeviceType.TABLET && TabletComponent) {
      return <TabletComponent {...props} />;
    }
    return <MobileComponent {...props} />;
  }
  return <DesktopComponent {...props} data-sentry-element="DesktopComponent" data-sentry-component="RenderComponents" data-sentry-source-file="RenderComponents.tsx" />;
};
export default RenderComponents;